export const DEADLINE_PROGRESS = {
  COMPLETE: 'COMPLETE',
  OVERDUE: 'OVERDUE',
  UPCOMING: 'UPCOMING',
  SUBMITTED_BUT_NOT_GRADED: 'SUBMITTED_BUT_NOT_GRADED',
} as const;
